import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {BannerImagesType} from '../../types/TypesNews';
import mediaPlaceholder from '../../assets/img/side_action.webp';
import styles from './MediaBannerCarousel.module.css';

interface MediaBannerCarouselProps {
	banners?: BannerImagesType[];
	height?: number;
}

const FALLBACK_BANNERS: BannerImagesType[] = [
	{img_link: mediaPlaceholder, news_id: 0},
	{img_link: mediaPlaceholder, news_id: 0},
	{img_link: mediaPlaceholder, news_id: 0},
];

const AUTO_SCROLL_INTERVAL = 5000; // 5 секунд

const MediaBannerCarousel: React.FC<MediaBannerCarouselProps> = ({
	banners,
	height = 180,
}) => {
	const navigate = useNavigate();
	const slides = banners && banners.length > 0 ? banners : FALLBACK_BANNERS;

	const [currentIndex, setCurrentIndex] = useState(0);
	const [isPaused, setIsPaused] = useState(false);

	// Автоматическая прокрутка
	useEffect(() => {
		if (slides.length <= 1 || isPaused) return;

		const interval = setInterval(() => {
			setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
		}, AUTO_SCROLL_INTERVAL);

		return () => clearInterval(interval);
	}, [slides.length, isPaused]);

	const handleBannerClick = () => {
		const currentSlide = slides[currentIndex];
		if (currentSlide?.news_id) {
			navigate(`/news/${currentSlide.news_id}`);
		}
	};

	const currentSlide = slides[currentIndex];
	const canNavigate = Boolean(currentSlide?.news_id);

	return (
		<div 
			className={styles.carousel} 
			style={{height}}
			onMouseEnter={() => setIsPaused(true)}
			onMouseLeave={() => setIsPaused(false)}
		>
			<button
				type="button"
				className={styles.imageButton}
				onClick={handleBannerClick}
				disabled={!canNavigate}
			>
				<img
					src={currentSlide?.img_link ?? mediaPlaceholder}
					alt={`sidebar-banner-${currentIndex + 1}`}
					className={styles.image}
				/>
			</button>
			<div className={styles.dots}>
				{slides.map((_, idx) => (
					<button
						type="button"
						key={`sidebar-banner-dot-${idx}`}
						className={`${styles.dot} ${idx === currentIndex ? styles.activeDot : ''}`}
						onClick={() => setCurrentIndex(idx)}
						aria-label={`Go to banner ${idx + 1}`}
					/>
				))}
			</div>
		</div>
	);
};

export default MediaBannerCarousel;
